export const environment = {
  env: 'Staging',
  production: false,
  apiBaseUrlOld: 'https://webapi-staging-v1.completumhealth.com/api/',
  apiBaseUrl: 'https://dhruvaapi-staging-v1.completumhealth.com/api/',
  apiKey: 'wTQiYUyz4qMHXbwgK36T2lHvDbr754dp',
  oldDhruva: 'https://web-staging-v1.completumhealth.com/dashboard',
  chatapi: 'https://chatapi-staging-v1.completumhealth.com',
  apiAccessKeyForChatapi: '7ef0c02e-9f9e-4258-b587-d4efcc17fde8',
  oldDhruvaUrl: 'https://web-staging-v1.completumhealth.com/',
  // Blood Report Tool Configuration
  bloodReportToolUrl:
    'https://ai-blood-report-extraction-staging-v1.completumhealth.com/',
  // Glucose Data Extraction Tool Configuration
  glucoseDataToolUrl:
    'https://ai-glucose-data-staging-v1.completumhealth.com/upload',
  // Biweekly Report Tool Configuration
  biweeklyReportToolUrl: 'https://ai-ml-staging-v1.completumhealth.com/user/',
  // Grocery List Generator API Configuration
  groceryListApiUrl: 'https://grocery-list-staging-v1.completumhealth.com',
  apiKeyForRestaurant: '87AF$C5648AE267A689D2A75CDD165~',
  favoriteRestaurantsApiUrl:
    'https://restaurants-finder-staging-v1.completumhealth.com/',

  NightlyNutritionScore: 'https://heald-nutrition-staging-v1.completumhealth.com/',
  CurrentDayNutritionScore: 'https://heald-nutrition-staging-v1.completumhealth.com/day-so-far/',
  MomoAPIUrl: 'https://momo-staging-v1.completumhealth.com/',
  MomoAPIKey: 'QA3rqnpbSlGvSgj6rNjJS97rsCAK5rKFoNh0Oxbleyg'
};
